import React, { useEffect, useState } from "react";

interface PasswordStrengthProps {
  password: string;
}
const PasswordStrengthIndicator: React.FC<PasswordStrengthProps> = ({
  password,
}) => {
  const [strength, setStrength] = useState(0);

  const getStrength = (pwd: string) => {
    let score = 0;
    if (pwd.length >= 6) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[a-z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;
    if (pwd.length >= 10 && score === 5) score++;
    return score;
  };

  useEffect(() => {
    setStrength(getStrength(password));
  }, [password]);

  const getBarColor = () => {
    if (strength <= 1) return "bg-red-500";
    if (strength === 2) return "bg-orange-500";
    if (strength === 3) return "bg-yellow-500";
    if (strength === 4) return "bg-green-500";
    return "bg-green-700";
  };

  const getSegmentColor = (index: number) => {
    if (strength <= index) return "bg-gray-200";
    if (strength === 1) return "bg-red-500";
    if (strength === 2) return "bg-orange-500";
    if (strength === 3) return "bg-yellow-500";
    if (strength === 4) return "bg-green-500";
    return "bg-green-700";
  };

  return (
    <div className="mx-auto w-full md:w-[400px]">
      <div className="h-1 w-full mt-2 rounded-md">
        <div className="flex gap-1 mt-2">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className={`h-1 flex-1 rounded-md transition-all ${getSegmentColor(
                index
              )}`}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;
